export default __webpack_public_path__ + "static/media/busable-logo-2.223664a0.svg";